/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGetDeveloperInfoResponseSchema } from '../../entities/schemas/GetDeveloperInfoResponseSchema';

export type TGetDeveloperInfoModel = IModel<IGetDeveloperInfoRequest, TGetDeveloperInfoResponse>;

export interface IGetDeveloperInfoRequest {
  /** Идентификатор застройщика **/
  developerId?: number | null;
}

export type TGetDeveloperInfoResponse =
  | IGetDeveloperInfoResponse200
  | IGetDeveloperInfoResponse400
  | IGetDeveloperInfoResponse404;

export interface IGetDeveloperInfoResponse200 extends IModelResponse<IGetDeveloperInfoResponse> {
  statusCode: 200;
}

export interface IGetDeveloperInfoResponse400 extends IModelResponse<IGetDeveloperInfoResponseError> {
  statusCode: 400;
}

export interface IGetDeveloperInfoResponse404 extends IModelResponse<IGetDeveloperInfoResponseNotFoundError> {
  statusCode: 404;
}

export interface IGetDeveloperInfoResponse {
  data: IGetDeveloperInfoResponseSchema;
  status: EStatus;
}

export interface IGetDeveloperInfoResponseError {
  errors: any[];
  message: string;
}

export interface IGetDeveloperInfoResponseNotFoundError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IGetDeveloperInfoResponse
  | IGetDeveloperInfoResponseError
  | IGetDeveloperInfoResponseNotFoundError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400, TResponse404> {
  200(response: IGetDeveloperInfoResponse): TResponse200;
  400(response: IGetDeveloperInfoResponseError): TResponse400;
  404(response: IGetDeveloperInfoResponseNotFoundError): TResponse404;
}
